export const sendStorageEvent = (key) => {
  try {
    if (window && window.dispatchEvent) {
      window.dispatchEvent(
        new StorageEvent('storage', {
          key,
        }),
      );
    }
  } catch (e) {
    console.log('cannot refresh display in service worker');
  }
  // else {
  //   self.clients.matchAll({ includeUncontrolled: true, type: 'window' }).then((clients) => {
  //     clients[0].postMessage({
  //       type,
  //       content,
  //     });
  //   });
  // }
};
